import { EmailViewer } from "@/components/activityEvents/EmailViewer";
import { SMSViewer } from "@/components/activityEvents/SMSViewer";
import { UserMessageViewer } from "@/components/activityEvents/UserMessageViewer";
import type { ActivityMessage } from "./opportunityActivitySentences";

/**
 * The full email, text, or chat message an activity line carries.
 * @param message - The message to show
 */
export const OpportunityActivityMessage = ({
  message,
}: {
  message: ActivityMessage;
}) => {
  if (message.type === "email") {
    return <EmailViewer emailContent={message.content} />;
  }
  if (message.type === "sms") {
    return <SMSViewer smsContent={message.content} />;
  }
  return (
    <UserMessageViewer
      message={message.message}
      messageType={message.messageType}
      messageLabel={message.messageLabel}
    />
  );
};
